export default "__VITE_ASSET__DkNJJhxm__"